// extracted by mini-css-extract-plugin
module.exports = {"topWinners":"OverflowSlider__topWinners--1t0","topWinner":"OverflowSlider__topWinner--2B1"};